import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { INDRAIBEEmailTesterService } from '@ibe.services/ibe-email-tester.indra.service';



@Component({
	selector: 'app-examples',
	templateUrl: './examples.component.html',
	styleUrls: ['./examples.component.scss']
})
export class ExamplesComponent implements OnInit, OnDestroy {
	
	emailAddress;
	constructor(
		private router: Router,
		private http: HttpClient,
		private emailTesterService: INDRAIBEEmailTesterService
	) {

	}

	ngOnInit() { }
	ngOnDestroy() { }
	
	public sendEmail() {
		console.log('sending commercial confirmation email');
		this.emailTesterService.send_ConfirmationEmail_commercial(this.emailAddress);
	}
	public sendAwardEmail() {
		console.log('sending award confirmation email');
		this.emailTesterService.send_ConfirmationEmail_award(this.emailAddress);
	}
	
	public sendTTTConfirmationEmail() {
		console.log('sending TTT confirmation email');
		this.emailTesterService.send_ConfirmationEmail_TTT(this.emailAddress);
	}
	
	public sendTTTExpirationWarningEmail() {
		console.log('sending TTT expiration warning email');
		this.emailTesterService.send_TTTexpirationWarningEmail(this.emailAddress);
	}
	
	public sendTTTExpiredEmail() {
		console.log('sending TTT expired email');
		this.emailTesterService.send_TTTexpiredEmail(this.emailAddress);
	}

	public emailAddressChange(event){
		if(event && event.target && event.target.value){
			this.emailAddress = event.target.value;
		}
	}

	public sendStopoverConfirmationEmail() {
		console.log('sending stopover confirmation email');
		this.emailTesterService.send_ConfirmationEmail_stopover(this.emailAddress);
	}

	public sendAddMoreEmail() {
		console.log('sending add more email');
		this.emailTesterService.send_addmore(this.emailAddress);
	}


}
